export default [
    {
        path: '/sync/',
        name: 'sync-device',
        component: () => import('@/views/sync/Sync.vue'),
    },
]